//
//
//
//

export default {
  components: {},

  data() {
    return {};
  },

  async created() {},
  methods: {

    async StartPay(orderItem) {
      await this.startWechatPay(orderItem);
    },

    async startWechatPay(orderItem) {
      var wechatOpenId = this.$route.query.wechatOpenId;
      if (!orderItem) {
        this.$msg.alert("OrderItem参数不能为空.");
        return;
      }

      if (!orderItem.OpenId) {
        this.$msg.alert("OrderItem参数不能为空.");
        return;
      }
      var url = "/mWechatApi/WechatPay/Pay";
      this.$msg.showLoading("正在支付...");
      var postData = {
        orderType: "99",
        orderOpenId: orderItem.OpenId,
      };

      let { data: result } = await this.$http({
        method: "post",
        url: url,
        data: postData
      });
      this.$msg.hideLoading();
      console.log("WechatPay/Pay---result", result);

      if (result.state == 1) {
        this._createWechatPay(result);
        return;
      }
      this.$msg.alert(result.msg);
      console.log(result);
    },

    //微信支付
    _createWechatPay(result) {
      var data = result.PayData;
      var payData = {
        appId: data.AppId, //公众号名称，由商户传入
        timeStamp: data.Timestamp,
        nonceStr: data.NonceStr,
        package: data.Package,
        signType: data.SignType,
        paySign: data.PaySign //微信签名
      };
      WeixinJSBridge.invoke("getBrandWCPayRequest", payData, res => {
        console.log("getBrandWCPayRequest", res);
        alert(res.err_msg);
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //支付成功
          //window.location.href = result.successUrl;
          this.$msg.alert(result.successUrl);
          return;
        } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          // 支付过程中用户取消

          this.$msg.alert("亲,您没有给我买单哦！", function() {});
          return;
        }
        this.$msg.alert(res.err_msg);
      });
    }
  }
};
